import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  'Web Development','Mobile App Development','UI/UX Design',
  'Digital Marketing','SEO Optimization','Cloud Solutions',
  'Custom Software','E-Commerce Development',
];

export default function Footer() {
  return (
    <footer className="vt-footer">
      <div className="vt-footer__body">
        <div className="vt-footer__inner">

          <div className="vt-footer__col vt-footer__col--brand">
            <div className="vt-footer__logo-row">
              <img src="/logo.jpg" alt="Vedanskrix" className="vt-footer__logo" />
              <div>
                <span className="vt-footer__brand-name">VEDANSKRIX</span>
                <span className="vt-footer__brand-sub">Tech Solutions</span>
              </div>
            </div>
            <p className="vt-footer__tagline">
              Empowering businesses with cutting-edge technology solutions — from web apps to digital marketing.
            </p>
            <div className="vt-footer__socials">
              <a href="https://wa.me/918758637022" target="_blank" rel="noreferrer" className="vt-footer__social" aria-label="WhatsApp">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 5.2a6.55 6.55 0 0 0-5.66 9.86L5.5 18.8l3.84-.82A6.55 6.55 0 1 0 12 5.2Z"/></svg>
              </a>
              <a href="#" className="vt-footer__social" aria-label="Facebook" onClick={e=>e.preventDefault()}>
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.2 18.5v-5.6h2l.3-2.3h-2.3V9.1c0-.67.19-1.12 1.15-1.12h1.23V5.92c-.21-.03-.95-.09-1.8-.09-1.79 0-3.01 1.09-3.01 3.09v1.72H9v2.3h2.02v5.56h2.18Z"/></svg>
              </a>
              <a href="#" className="vt-footer__social" aria-label="Instagram" onClick={e=>e.preventDefault()}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="6.2" y="6.2" width="11.6" height="11.6" rx="3"/><circle cx="12" cy="12" r="2.9"/><circle cx="16.1" cy="7.9" r="0.7" fill="currentColor" stroke="none"/></svg>
              </a>
            </div>
          </div>

          <div className="vt-footer__col">
            <h4 className="vt-footer__col-title">Quick Links</h4>
            <ul className="vt-footer__list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="vt-footer__col">
            <h4 className="vt-footer__col-title">Our Services</h4>
            <ul className="vt-footer__list">
              {services.map(s => (
                <li key={s}><Link to="/services">{s}</Link></li>
              ))}
            </ul>
          </div>

          <div className="vt-footer__col">
            <h4 className="vt-footer__col-title">Contact Us</h4>
            <div className="vt-footer__contact">
              <p>E-106 Akshardham Heights,<br/>S.P. Ring Road, Vastral Road,<br/>Ahmedabad, Gujarat 382418</p>
              <p><strong>Email:</strong> vedanskrix@gmail.com</p>
              <p><strong>Web:</strong> vedanskrix.com</p>
              <Link to="/contact" className="vt-footer__cta-btn">Get Free Quote →</Link>
            </div>
          </div>

        </div>
      </div>
      <div className="vt-footer__bottom">
        <div className="vt-footer__bottom-inner">
          <span>© {new Date().getFullYear()} Vedanskrix Web LLP — All Rights Reserved</span>
          <div className="vt-footer__bottom-links">
            <Link to="/contact">Privacy Policy</Link>
            <Link to="/contact">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
